<template>
  <div :class="['dropdown account-info', { 'white-theme': specialHeader }]">
    <a
      class="nickname"
      href="javascript:void(0)"
      data-toggle="dropdown"
      role="button"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <span>{{ nickName }}</span>
      <span class="caret"></span>
    </a>
    <ul id="account-ul" class="dropdown-menu" aria-labelledby="dLabel">
      <!-- <li v-if="isAdmin"><a :href="backendLink" target="_blank">{{ $t('backend') }}</a></li> -->
      <li>
        <router-link to="/dashboard">{{ $t("myAccount") }}</router-link>
      </li>
      <li>
        <a href="javascript:void(0)" @click="signOut">{{ $t("signOut") }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
import locales from "./lang";
import { mapState } from "vuex";

export default {
  name: "header-account-info",
  locales,
  computed: {
    isAdmin() {
      return this.$store.state.user.role === "admin";
    },
    backendLink() {
      return (
        this.$http.options.root.replace(/www/, "api") +
        "/transitToAdmin/" +
        window.localStorage.getItem("token")
      );
    },
    ...mapState({
      nickName: (state) => state.user["nickname"],
      specialHeader: (state) => state.header.specialHeader,
      isHeader: "isHeader",
    }),
  },
  methods: {
    signOut() {
      this.$store.dispatch("clearUserInfo");
      this.$router.replace("/");
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "../../../../assets/scss/activity.scss";

* {
  padding: 0;
  margin: 0;
}

.account-info {
  color: #fff;
  .nickname {
    font-size: 16px;
    color: #333333;
    letter-spacing: 0.89px;
    text-align: center;
    font-weight: 500;
  }
}

#account-ul {
  background: #fff;
  border: 1px solid #efefef;
  box-shadow: 0 0.06rem 0.24rem 0 rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  padding: 0 0.1rem;
  top: 0.42rem;
  li {
    border-bottom: 1px solid #efefef;
    text-align: center;
    &:last-child {
      border-bottom: none;
    }
    a {
      line-height: 0.6rem;
      height: 0.6rem;
      font-size: 14px;
      color: #333;
      letter-spacing: 0.33px;
      &:hover {
        background: transparent;
        font-weight: bold;
        font-size: 0.16rem;
        letter-spacing: 0.38px;
      }
    }
  }
}

// @mixin default-theme() {
//   .nickname {
//     // color: $header-account-default-theme;
//     color: #fff;
//   }
// }

// @mixin white-theme() {
//   .nickname {
//     color: #fff;
//   }
// }

// .account-info {
//   @include default-theme();
//   &.white-theme {
//     @include white-theme();
//   }
// }
</style>



// WEBPACK FOOTER //
// AccountInfo.vue?2975dedb